import React from 'react';
import Errors from 'shared/components/Errors';

export default props => <Errors render={defaultRender} {...props} />;

const defaultRender = errors => (
  <div className="content">
    <div className="error_messages">
      <h5>Please correct the following:</h5>
      <ul>
        {errors.map((error, idx) => (
          <li key={idx}>{error}</li>
        ))}
      </ul>
    </div>
  </div>
);
